//Components
import Footer from "component/Footer";

export default function ViewTab() {
  return (
    <>
      <main className="bg-slate-50 min-h-screen">
        <h1>here you can see the tabs you are looking for</h1>
      </main>
      <Footer />
    </>
  );
}
